import React, { useEffect, useMemo, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getVoiceTelemetry } from '../../../api/backendApi';

export default function VoiceTelemetryTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const refresh = async () => {
    setLoading(true); setError('');
    try {
      const resp = await getVoiceTelemetry();
      const list = Array.isArray(resp?.data) ? resp.data : Array.isArray(resp) ? resp : [];
      // normalize id
      setRows(list.map((r, idx) => ({ id: r.id || r.sid || `${idx}`, ...r })));
    } catch (e) {
      setError(String(e?.message || 'Failed to load telemetry'));
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  const columns = useMemo(() => ([
    { field: 'timestamp', headerName: 'Timestamp', flex: 1, valueGetter: p => p.row.timestamp ? new Date(p.row.timestamp).toLocaleString() : '' },
    { field: 'tenantId', headerName: 'Tenant', flex: 1 },
    { field: 'purpose', headerName: 'Purpose', flex: 1 },
    { field: 'e164_from', headerName: 'From', flex: 1 },
    { field: 'source', headerName: 'Source', flex: 1 },
    { field: 'rule_hit', headerName: 'Rule Hit', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
    { field: 'errorCode', headerName: 'Error', flex: 1 },
  ]), []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>;
  if (error) return <Box sx={{ color: 'error.main' }}>{error}</Box>;

  return (
    <Box>
      <Box sx={{ height: 440, width: '100%' }}>
        <DataGrid rows={rows} columns={columns} density="compact" disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} />
      </Box>
    </Box>
  );
}
